<template>
  <div>
      <div class="panel panel--minimal-pad">
        <div class="panel__header">
          <div class="panel__header__left panel__header-width-m">
            	Transfer Details
          </div>
          <div class="panel__header__right">
            <div class="" style="padding-right: 10px;" v-if="shouldShow">
              <button id="retry" type="submit" class="btn btn--primary"
              data-toggle="modal"
              data-target="#createRetryModal"
              >Retry Transfer</button>
            </div>
            <div class="filter__options">
              <!--<button class="btn btn&#45;&#45;default btn&#45;&#45;flex">-->
                <select name="disburse-source" id="disburseSource" class="select__input select__input--sm" @change="optionType()" v-model="type">
                  <option value=""> Select an option </option>
                  <option v-if="transfer.status == 'completed' && transfer.dest == 'beneficiary'" value="Email">Email transfer receipts</option>
                  <option v-if="transfer.status == 'completed' && transfer.dest == 'beneficiary'" value="View">View transfer receipts</option>
                  <option v-if="transfer.source == 'pos' || transfer.source == 'pos-mobile'" value="retryCallBack">Retry Callback</option>
                  <option v-if="transfer.blackListed && transfer.status == 'completed' && transfer.dest == 'beneficiary'" value="RFBlacklist">Remove from Blacklist</option>
                  <option v-else-if="!transfer.blackListed && transfer.status !== 'completed' && transfer.dest === 'beneficiary'" value="Blacklist">BlackList Beneficiary</option>
                  <option v-if="transfer.source === 'pos' || transfer.source == 'pos-mobile'" value="logTransfer">Log Dispense Error</option>
                  <!-- <option value="report">Report Transfer</option> -->
                </select>
              <div class="select__icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10"><path fill="#42476f" fill-rule="evenodd" d="M6.03 3.03L3.025.025.02 3.03h6.01zM5.88 7.071L2.975 9.975.07 7.07H5.88z"></path></svg>
              </div>
                <!-- <span class="btn__icon">
                  <svg class="" enable-background="new 0 0 971.986 971.986" version="1.1" viewBox="0 0 971.986 971.986" xml:space="preserve" xmlns="http://www.w3.org/2000/svg">
                      <path fill="#576ae6" d="m370.22 459.3c10.2 11.1 15.8 25.6 15.8 40.6v442c0 26.601 32.1 40.101 51.1 21.4l123.3-141.3c16.5-19.8 25.6-29.601 25.6-49.2v-272.8c0-15 5.7-29.5 15.8-40.601l353.8-383.9c26.5-28.8 6.101-75.5-33.1-75.5h-873c-39.2 0-59.7 46.6-33.1 75.5l353.8 383.8z" />
                  </svg>
                </span>
                  <span class="btn__text">Add filter</span> -->
              <!--</button>-->
            </div>
          </div>
        </div>
        <!--equalized tables, for want of a better name, sigh-->
        <div class="panel__content panel__content--grey outer-container equalized-tables">
          <!--transfer history table-->

          <!--transfer loading-->
          <div class="loaderContainer" v-if="isLoading">
            <img src="/static/wave.gif" alt="" width="32" height="32">
          </div>

          <div v-if="!isLoading">
            <div class="table__section table__section--head">
              Transaction <span>Status</span>
            </div>
            <div class="card">
              <div class="card__content card__content--flex">
                <table width="100%">
                  <tr>
                    <td width="15%">
                      <span>AMOUNT</span><br>
                      {{ transfer.currency }} {{ transfer.amount | numeralize('0,0.00') }}
                    </td>
                    <td width="12%">
                      FEE<br>
                      {{ transfer.currency }} {{ transfer.fee }}
                    </td>
                    <td width="15%">
                      STATUS<br>
                      <span v-if="transfer.reversed" class="tag" :class="['tag--reversed']">Reversed</span>
                      <span v-else class="tag" :class="['tag--' + transfer.status]">{{transfer.status}}</span>
                    </td>
                    <td>
                      REFERENCE<br>
                      {{ transfer.ref }}
                    </td>
                    <td v-if="transfer.dest === 'bill'">
                      NARRATION<br>
                      {{ transfer.custom_narration || '-' }}
                    </td>
                    <td width="20%">
                      <span>DATE</span><br>
                      {{ momentDate(transfer.createdAt) }}
                    </td>
                  </tr>
                </table>
              </div>
            </div>

            <br>

            <div class="table__section table__section--head" v-if="transfer.dest == 'beneficiary'">
              Payout <span>Beneficiary</span>
            </div>

            <div class="card"  v-if="transfer.dest == 'beneficiary'">
              <div class="card__content card__content--flex">
                <table width="100%">
                  <tr>
                    <td width="25%">
                      ACCOUNT NUMBER<br>
                      {{ transfer.accountNumber }}
                    </td>
                    <td width="30%">
                      BANK<br>
                      {{ transfer.bankName }}
                    </td>
                    <td width="30%" v-if="transfer.accountName === '.' || transfer.accountName === null">
                      <span>ACCOUNT NAME</span><br>
                      {{ transfer.beneficiary }}
                    </td>
                    <td width="27%" v-else>
                      <span>ACCOUNT NAME</span><br>
                      {{ transfer.accountName }}
                    </td>
                    <td>
                      <span v-if="transfer.blackListed" class="tag" :class="['tag--reversed']">BlackListed</span>
                    </td>
                  </tr>
                </table>
              </div>
            </div>

            <div class="table__section table__section--head" v-if="transfer.system_type == 'wallet-fund'">
              Funding <span>Details</span>
            </div>

            <div class="card"  v-if="transfer.system_type == 'wallet-fund'">
              <div class="card__content card__content--flex">
                <table width="100%">
                  <tr v-if="transfer.source == 'pos' || transfer.source == 'pos-mobile'">
                    <td width="29%">
                      CHANNEL<br>
                      {{ transfer.source.toUpperCase() }} Terminal - {{ transfer.custom_terminalid }}
                    </td>
                    <td>
                      POS ID <br>
                      {{ transfer.custom_posid }}
                    </td>
                    <td width="50%">
                      CARD<br>
                      {{ transfer.custom_mask }}
                    </td>
                  </tr>

                  <tr v-if="transfer.source == 'wire'">
                    <td width="50%">
                      SOURCE<br>
                      {{ transfer.custom_originatorname }} ({{ transfer.custom_originatoraccountnumber }})
                    </td>
                    <td>
                      NARRATION<br>
                      {{ transfer.custom_narration }}
                    </td>
                  </tr>

                  <tr v-if="transfer.source == 'system'">
                    <td>
                      NARRATION<br>
                      {{ transfer.narration }}
                    </td>
                  </tr>
                </table>
              </div>
            </div>


            <br>

            <div class="table__section table__section--head" v-if="transfer.dest == 'beneficiary'">
              Additional <span>Info</span>
            </div>

            <div class="card" v-if="transfer.dest == 'beneficiary'">
              <div class="card__content card__content--flex">
                <table width="100%">
                  <tr>
                    <td width="25%">
                      FLW REFERENCE<br>
                      <span>{{ transfer.flutterReference }}</span>
                      <span v-if="transfer.linkingReference"> / {{ transfer.linkingReference }}</span>
                    </td>
                    <td>
                      NARRATION<br>
                      {{ transfer.narration || 'none' }}
                    </td>
                    <td width="45%" v-if="transfer.currency !== 'KES'">
                      SESSION ID <br>
                      {{transfer.sessionId || 'N/A'}}
                    </td>
                    <td width="45%" v-else>
                      PROCESSOR REFERENCE <br>
                      {{transfer.processorReference || 'N/A'}}
                    </td>
                  </tr>
                </table>
              </div>
            </div>

            <br>

            <div class="table__section table__section--head" v-if="transfer.status === 'error' || transfer.reversed">
              Reversal <span>Info</span>
            </div>

            <div class="card" v-if="transfer.status === 'error' || transfer.reversed">
              <div class="card__content card__content--flex">
                <table width="100%">
                  <tr>
                    <td width="30%">
                      Reason<br>
                      {{ transfer.flutterResponseMessage }}
                    </td>
                    <td width="30%">
                      Reversal REFERENCE<br>
                      <span> {{ reversedTransfer.ref }}</span>
                    </td>
                    <td width="20%">
                      Amount<br>
                      {{ (reversedTransfer.amount + reversedTransfer.fee) || 'none' }}
                    </td>
                    <td>
                      DATE<br>
                      {{ momentDate(reversedTransfer.createdAt) }}
                    </td>
                  </tr>
                </table>
              </div>
            </div>

            <br>

            <div class="table__section table__section--head" v-if="retriedList">
              Retry <span>Attempts</span>
            </div>
            <div v-if="retriedList" v-for="list in retriedList">
              <div class="card">
                <div class="card__content card__content--flex">
                  <table width="100%">
                    <tr>
                      <td width="30%">
                        Reason<br>
                        {{ list.flutterResponseMessage }}
                      </td>
                      <td width="30%">
                        Retry REFERENCE<br>
                        <span> {{ list.ref }}</span>
                      </td>
                      <td>
                        DATE<br>
                        {{ momentDate(list.createdAt) }}
                      </td>
                      <td>
                        STATUS<br>
                        <span v-if="list.reversed" class="tag" :class="['tag--reversed']">Reversed</span>
                        <span v-else class="tag" :class="['tag--' + list.status]">{{list.status}}</span>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
              <br>
            </div>


          </div>

        </div>
      </div>
    <div
      class="modal fade"
      id="createRetryModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="createRetryModal"
    >
    <div class="modal__dialog modal__dialog--lg">
        <!-- Modal content -->
        <div class="modal__content">
          <div class="modal__header">
            <div class="modal__title">
              <span class="time-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  version="1.1"
                  id="Capa_1"
                  x="0px"
                  y="0px"
                  width="512px"
                  height="512px"
                  viewBox="0 0 612 612"
                  style="enable-background:new 0 0 612 612;"
                  xml:space="preserve"
                  class="icon--sm"
                >
                  <g>
                    <g>
                      <g>
                        <path
                          d="M587.572,186.881c-32.266-75.225-87.096-129.934-162.949-162.285C386.711,8.427,346.992,0.168,305.497,0.168    c-41.488,0-80.914,8.181-118.784,24.428C111.488,56.861,56.415,111.535,24.092,186.881C7.895,224.629,0,264.176,0,305.664    c0,41.496,7.895,81.371,24.092,119.127c32.323,75.346,87.403,130.348,162.621,162.621c37.877,16.247,77.295,24.42,118.784,24.42    c41.489,0,81.214-8.259,119.12-24.42c75.853-32.352,130.683-87.403,162.956-162.621C603.819,386.914,612,347.16,612,305.664    C612,264.176,603.826,224.757,587.572,186.881z M538.724,440.853c-24.021,41.195-56.929,73.876-98.375,98.039    c-41.195,24.021-86.332,36.135-134.845,36.135c-36.47,0-71.27-7.024-104.4-21.415c-33.129-14.384-61.733-33.294-85.661-57.215    c-23.928-23.928-42.973-52.811-57.214-85.997c-14.199-33.065-21.08-68.258-21.08-104.735c0-48.52,11.921-93.428,35.807-134.509    c23.971-41.231,56.886-73.947,98.039-98.04c41.146-24.092,85.99-36.142,134.502-36.142c48.52,0,93.649,12.121,134.845,36.142    c41.446,24.164,74.283,56.879,98.375,98.039c24.092,41.153,36.135,85.99,36.135,134.509    C574.852,354.185,562.888,399.399,538.724,440.853z"
                          data-original="#000000"
                          class="active-path"
                          data-old_color="#576ae6"
                          fill="#576ae6"
                        ></path>
                        <path
                          d="M324.906,302.988V129.659c0-10.372-9.037-18.738-19.41-18.738c-9.701,0-18.403,8.366-18.403,18.738v176.005    c0,0.336,0.671,1.678,0.671,2.678c-0.671,6.024,1.007,11.043,5.019,15.062l100.053,100.046c6.695,6.695,19.073,6.695,25.763,0    c7.694-7.695,7.188-18.86,0-26.099L324.906,302.988z"
                          data-original="#000000"
                          class="active-path"
                          data-old_color="#576ae6"
                          fill="#576ae6"
                        ></path>
                      </g>
                    </g>
                  </g>
                </svg>
              </span>
              Retry Transfer
            </div>
          </div>
          <!-- Modal Body -->
          <div class="modal__body modal__body--pad">
            <div class>
              <form
                action
                class="form disburse-form"
                @submit.prevent="handleRetryTransfer()"
                v-if="transferWaiting"
              >
                <div class="form__item">
                  <label for="beneficiarySource" class="form__label--span form--left">
                    Wallet
                    <span>Password</span>
                  </label>
                  <div class="select form--right">
                    <input
                      type="password"
                      name="lockCode"
                      v-model="password"
                      id="lockCode"
                      class="form__input input"
                      data-vv-id="1"
                      aria-required="true"
                      aria-invalid="false"
                    >
                  </div>
                </div>

                <div class="form__item">
                  <button
                    id="retryTransfer"
                    type="submit"
                    class="btn btn--primary btn--block retry_submit"
                  >Retry Transfer</button>
                </div>
              </form>

              <div class="disburse__result text-center" v-if="!transferWaiting">
                <div v-if="transferSuccessful">
                  <!--success icon-->
                  <div class="result-img">
                    <svg
                      class="icon icon--custom-big"
                      enable-background="new 0 0 50 50"
                      version="1.1"
                      viewBox="0 0 50 50"
                      xml:space="preserve"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="25" cy="25" r="25" fill="#25AE88"></circle>
                      <polyline
                        points="38 15 22 33 12 25"
                        fill="none"
                        stroke="#fff"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-miterlimit="10"
                        stroke-width="2"
                      ></polyline>
                    </svg>
                  </div>
                  <p
                    class="disburse__result__success success-text"
                  >Transfer successfully Retried!</p>
                  <button
                    class="btn btn--primary"
                    data-dismiss="modal"
                    aria-label="Close"
                    @click="change()">
                    <span>Close</span>
                  </button>
                </div>

                <div v-if="transferFailed">
                  <div class="result-img">
                    <svg
                      enable-background="new 0 0 50 50"
                      version="1.1"
                      viewBox="0 0 50 50"
                      xml:space="preserve"
                      xmlns="http://www.w3.org/2000/svg"
                      class="icon icon--custom-big"
                    >
                      <circle cx="25" cy="25" r="25" fill="#D75A4A"></circle>
                      <polyline
                        points="16 34 25 25 34 16"
                        fill="none"
                        stroke="#fff"
                        stroke-linecap="round"
                        stroke-miterlimit="10"
                        stroke-width="2"
                      ></polyline>
                      <polyline
                        points="16 16 25 25 34 34"
                        fill="none"
                        stroke="#fff"
                        stroke-linecap="round"
                        stroke-miterlimit="10"
                        stroke-width="2"
                      ></polyline>
                    </svg>
                  </div>
                  <p
                    v-for="error in transferErrors"
                    class="disburse__result__error error-text"
                  >{{error}}</p>
                  <button class="btn btn--primary" @click="retry2()">Retry</button>
                  <button
                    class="btn btn--default"
                    data-dismiss="modal"
                    aria-label="Close"
                    @click="change()"
                  >
                    <span>Close</span>
                  </button>
                  <!-- <button
                    class="btn btn--default"
                    data-dismis="modal"
                    aria-label="Close"
                    data-toggle="modal"
                    data-target="#createRetryModal"
                  >See all beneficiaries</button> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade in"
      id="callbackModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="callbackModal" style="display: block;" v-if="callbackInitiated">

      <div class="modal__dialog modal__dialog--xlg">
        <!-- Modal content -->
        <div class="modal__content">
          <div class="modal__header">
            <div class="modal__title">
              <span class="time-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  version="1.1"
                  id="Capa_1"
                  x="0px"
                  y="0px"
                  width="512px"
                  height="512px"
                  viewBox="0 0 612 612"
                  style="enable-background:new 0 0 612 612;"
                  xml:space="preserve"
                  class="icon--sm"
                >
      <g>
        <g>
          <g>
            <path
              d="M587.572,186.881c-32.266-75.225-87.096-129.934-162.949-162.285C386.711,8.427,346.992,0.168,305.497,0.168    c-41.488,0-80.914,8.181-118.784,24.428C111.488,56.861,56.415,111.535,24.092,186.881C7.895,224.629,0,264.176,0,305.664    c0,41.496,7.895,81.371,24.092,119.127c32.323,75.346,87.403,130.348,162.621,162.621c37.877,16.247,77.295,24.42,118.784,24.42    c41.489,0,81.214-8.259,119.12-24.42c75.853-32.352,130.683-87.403,162.956-162.621C603.819,386.914,612,347.16,612,305.664    C612,264.176,603.826,224.757,587.572,186.881z M538.724,440.853c-24.021,41.195-56.929,73.876-98.375,98.039    c-41.195,24.021-86.332,36.135-134.845,36.135c-36.47,0-71.27-7.024-104.4-21.415c-33.129-14.384-61.733-33.294-85.661-57.215    c-23.928-23.928-42.973-52.811-57.214-85.997c-14.199-33.065-21.08-68.258-21.08-104.735c0-48.52,11.921-93.428,35.807-134.509    c23.971-41.231,56.886-73.947,98.039-98.04c41.146-24.092,85.99-36.142,134.502-36.142c48.52,0,93.649,12.121,134.845,36.142    c41.446,24.164,74.283,56.879,98.375,98.039c24.092,41.153,36.135,85.99,36.135,134.509    C574.852,354.185,562.888,399.399,538.724,440.853z"
              data-original="#000000"
              class="active-path"
              data-old_color="#576ae6"
              fill="#576ae6"
            ></path>
            <path
              d="M324.906,302.988V129.659c0-10.372-9.037-18.738-19.41-18.738c-9.701,0-18.403,8.366-18.403,18.738v176.005    c0,0.336,0.671,1.678,0.671,2.678c-0.671,6.024,1.007,11.043,5.019,15.062l100.053,100.046c6.695,6.695,19.073,6.695,25.763,0    c7.694-7.695,7.188-18.86,0-26.099L324.906,302.988z"
              data-original="#000000"
              class="active-path"
              data-old_color="#576ae6"
              fill="#576ae6"
            ></path>
          </g>
        </g>
      </g>
    </svg>
              </span>
              Callback
            </div>
            <button
              type="button"
              class="close btn btn--default btn--sm"
              data-dismiss="modal"
              aria-label="Close"
              ref="closeModal"
              @click="change()"
            >
              <span>Close</span>
            </button>
          </div>

          <div class="modal__body modal__body--pad">
            <div class="disburse__result text-center">
                <div v-if="callbackSuccessful">
                  <!--success icon-->
                  <div class="result-img">
                    <svg
                      class="icon icon--custom-big"
                      enable-background="new 0 0 50 50"
                      version="1.1"
                      viewBox="0 0 50 50"
                      xml:space="preserve"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                    <circle cx="25" cy="25" r="25" fill="#25AE88"></circle>
                      <polyline
                        points="38 15 22 33 12 25"
                        fill="none"
                        stroke="#fff"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-miterlimit="10"
                        stroke-width="2"
                      ></polyline>
                  </svg>
                  </div>
                  <p v-for="message in callbackMessage" class="disburse__result__success success-text"
                  >{{message}}</p>
                  <button
                    aria-label="Close"
                    data-dismis="modal"
                    class="btn btn--primary"
                    @click="change()"
                  >Close</button>
                </div>

                <div v-if="callbackFailed">
                  <div class="result-img">
                    <svg
                      enable-background="new 0 0 50 50"
                      version="1.1"
                      viewBox="0 0 50 50"
                      xml:space="preserve"
                      xmlns="http://www.w3.org/2000/svg"
                      class="icon icon--custom-big"
                    >
                    <circle cx="25" cy="25" r="25" fill="#D75A4A"></circle>
                      <polyline
                        points="16 34 25 25 34 16"
                        fill="none"
                        stroke="#fff"
                        stroke-linecap="round"
                        stroke-miterlimit="10"
                        stroke-width="2"
                      ></polyline>
                      <polyline
                        points="16 16 25 25 34 34"
                        fill="none"
                        stroke="#fff"
                        stroke-linecap="round"
                        stroke-miterlimit="10"
                        stroke-width="2"
                      ></polyline>
                  </svg>
                  </div>
                  <p v-for="error in callbackErrors" class="disburse__result__error error-text"
                  >{{error}}</p>
                  <button
                    class="btn btn--primary"
                    data-dismiss="modal"
                    aria-label="Close"
                    @click="change()"
                  >Close</button>
                </div>
              </div>
            <!--</div>-->
          </div>

        </div>
      </div>
    </div>
    <div
      class="modal fade in"
      id="confirmPaymentModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="confirmPaymentModal" style="display: block;" v-if="initiated"
    >
      <!-- Modal Dialog -->
      <div class="modal__dialog modal__dialog--lg" role="document">
        <!-- Modal content -->
        <div class="modal__content">
          <div class="modal__header">
            <div class="modal__title">Email Transfer
              <span>Receipt</span>
            </div>
            <!-- Modal close button -->
            <button
                    type="button"
                    class="close btn btn--default btn--sm"
                    data-dismiss="modal"
                    aria-label="Close"
                    ref="closeModal"
                    @click="change()"
            >
              <span>Close</span>
            </button>
          </div>
          <!-- Modal Body -->
          <div class="modal__body modal__body--pad">
            <form action="" class="form disburse-form" v-if="toTypeEmail" @submit.prevent="handleSendReceipts()">
              <div class="form__item">
                <label for="disburseSource" class="form__label--span form--left"> Email </label>
                <input type="text" class="form__input" v-model="email">
              </div>
              <div class="form__item">
                <button class="btn btn--primary btn--block submit__paymentForm" type="button" @click="handleSendReceipts()" > Submit </button>
              </div>
            </form>

            <div class="disburse__result text-center" v-if="!toTypeEmail">
              <div v-if="EmailSentSuccessfully">
                <!--success icon-->
                <div class="result-img">
                  <svg
                          class="icon icon--custom-big"
                          enable-background="new 0 0 50 50"
                          version="1.1"
                          viewBox="0 0 50 50"
                          xml:space="preserve"
                          xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="25" cy="25" r="25" fill="#25AE88"></circle>
                    <polyline
                            points="38 15 22 33 12 25"
                            fill="none"
                            stroke="#fff"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-miterlimit="10"
                            stroke-width="2"
                    ></polyline>
                  </svg>
                </div>
                <p class="disburse__result__success success-text">Email sent successfully!</p>
                <button
                        class="btn btn--primary"
                        @click="change()"
                >Close</button>
              </div>

              <div v-if="EmailFailed">
                <div class="result-img">
                  <svg
                          enable-background="new 0 0 50 50"
                          version="1.1"
                          viewBox="0 0 50 50"
                          xml:space="preserve"
                          xmlns="http://www.w3.org/2000/svg"
                          class="icon icon--custom-big"
                  >
                    <circle cx="25" cy="25" r="25" fill="#D75A4A"></circle>
                    <polyline
                            points="16 34 25 25 34 16"
                            fill="none"
                            stroke="#fff"
                            stroke-linecap="round"
                            stroke-miterlimit="10"
                            stroke-width="2"
                    ></polyline>
                    <polyline
                            points="16 16 25 25 34 34"
                            fill="none"
                            stroke="#fff"
                            stroke-linecap="round"
                            stroke-miterlimit="10"
                            stroke-width="2"
                    ></polyline>
                  </svg>
                </div>
                <p
                        v-for="err in error"
                        class="disburse__result__error error-text"
                >{{err}}</p>
                <button
                        class="btn btn--primary"
                        @click="retry()"
                >Retry Sending receipts</button>
                <button
                        class="btn btn--default"
                        @click="change()"
                >Close</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
    class="modal fade in"
      id="createSureModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="createSureModal" style="display: block;" v-if="toView">
      <div class="modal__dialog modal__dialog--xlg" role="document">
        <div class="modal__content">
          <div class="modal__header">
            <div class="modal__title">View Transfer
              <span>Receipt</span>
            </div>
            <!-- Modal close button -->
            <button
                    type="button"
                    class="close btn btn--default btn--sm"
                    data-dismiss="modal"
                    aria-label="Close"
                    ref="closeModal"
                    @click="change()"
            >
              <span>Close</span>
            </button>
          </div>
          <div class="modal__body modal__body--pad">
            <div class="modal-container" style="width:90%; margin:auto;">
                <div class="modal-header" style="display: flex; justify-content: space-between; padding-bottom: 10px;">
                    <p class="receipt-id" style="font-weight:bold; color: #7C7676;"> RECEIPT #{{transfer.flutterReference}}</p>
                    <p class="receipt-date">{{transfer.createdAt | moment('MMM DD, YYYY') }}</p>
                </div>
                <div style="background-color: white;">

                    <div class="receipt-body" style="padding:10px 10px 30px 4px; border-top: 1px solid lightgrey; display: flex; justify-content: space-between">
                        <div class="receipt-body__left" style="width: 40%">
                            <p style="color: #7C7676; font-weight: bold; font-size: 20px;"> {{merchant}} </p>
                        </div>
                        <div class="receipt-body__right" style="display:flex; flex-direction: column; align-items: space-between; width: 60%; ">
                            <div class="receipt-body_payment-details">
                                <p style="color: #7C7676; font-weight: bold;">Payment Details:</p>
                            </div>
                            <div style="display:flex; justify-content: space-between; padding: 4px 0px;">
                                <p style="width:50%;">Currency:</p>
                                <p style="width:50%; text-align:right">{{transfer.currency}}</p>
                            </div>
                            <div style="display:flex;justify-content: space-between; padding: 4px 0px;">
                                <p>Bank Name:</p>
                                <p>{{transfer.bankName || '-'}}</p>

                            </div>
                            <div style="display:flex;justify-content: space-between; padding: 4px 0px;">
                                <p>Account Number:</p>
                                <p>{{transfer.accountNumber || '-'}}</p>

                            </div>

                            <div style="display:flex;justify-content: space-between; padding: 4px 0px;">
                                <p>Account Name:</p>
                                <p v-if="transfer.accountName === '.' || transfer.accountName === null">{{transfer.beneficiary || '-'}}</p>
                                <p v-else>{{transfer.accountName}}</p>

                            </div>

                            <div style="display:flex;justify-content: space-between; padding: 4px 0px;">
                                <p>Merchant Reference:</p>
                                <p>{{transfer.ref}}</p>

                            </div>
                             <div style="display:flex;justify-content: space-between; padding: 4px 0px;">
                                <p>Linking Reference:</p>
                                <p>{{transfer.linkingReference || '-'}}</p>

                            </div>
                        </div>

                    </div>

                    <div style="border: 1px solid lightgray;">
                        <div style="display: flex; background-color: #eee;">
                            <p style="padding-left: 10px; padding-top: 7px; padding-bottom: 7px; width: 50%; height: 100%; border-right: 1px solid lightgrey;">Description</p>
                            <p style="padding-left: 10px; padding-top: 7px; padding-bottom: 7px; width: 25%; height: 100%; border-right: 1px solid lightgrey;">Status</p>
                            <p style="padding-left: 10px; padding-top: 7px; padding-bottom: 7px; width: 25%; height: 100%; border-right: 1px solid lightgrey;">Amount</p>
                        </div>
                        <div style="display: flex; padding-top: 7px; padding-bottom: 7px;">
                            <p style="padding-left: 10px; width: 50%; border-right: 1px solid lightgrey;">{{transfer.narration}}</p>
                            <p style=" padding-left: 10px; width: 25%; border-right: 1px solid lightgrey;">{{transfer.status}}</p>
                            <p style="padding-left: 10px; width: 25%; border-right: 1px solid lightgrey;">{{transfer.amount | numeralize('0,0.00')}}</p>
                        </div>
                    </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade in"
      id="createDispenseErrorModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="createDispenseErrorModal" style="display: block;" v-if="toLogTransfer"
    >
      <!-- Modal Dialog -->
      <div class="modal__dialog modal__dialog--lg" role="document">
        <!-- Modal content -->
        <div class="modal__content">
          <div class="modal__header">
            <div class="modal__title">
              <span class="time-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  version="1.1"
                  id="Capa_1"
                  x="0px"
                  y="0px"
                  width="512px"
                  height="512px"
                  viewBox="0 0 612 612"
                  style="enable-background:new 0 0 612 612;"
                  xml:space="preserve"
                  class="icon--sm"
                >
                  <g>
                    <g>
                      <g>
                        <path
                          d="M587.572,186.881c-32.266-75.225-87.096-129.934-162.949-162.285C386.711,8.427,346.992,0.168,305.497,0.168    c-41.488,0-80.914,8.181-118.784,24.428C111.488,56.861,56.415,111.535,24.092,186.881C7.895,224.629,0,264.176,0,305.664    c0,41.496,7.895,81.371,24.092,119.127c32.323,75.346,87.403,130.348,162.621,162.621c37.877,16.247,77.295,24.42,118.784,24.42    c41.489,0,81.214-8.259,119.12-24.42c75.853-32.352,130.683-87.403,162.956-162.621C603.819,386.914,612,347.16,612,305.664    C612,264.176,603.826,224.757,587.572,186.881z M538.724,440.853c-24.021,41.195-56.929,73.876-98.375,98.039    c-41.195,24.021-86.332,36.135-134.845,36.135c-36.47,0-71.27-7.024-104.4-21.415c-33.129-14.384-61.733-33.294-85.661-57.215    c-23.928-23.928-42.973-52.811-57.214-85.997c-14.199-33.065-21.08-68.258-21.08-104.735c0-48.52,11.921-93.428,35.807-134.509    c23.971-41.231,56.886-73.947,98.039-98.04c41.146-24.092,85.99-36.142,134.502-36.142c48.52,0,93.649,12.121,134.845,36.142    c41.446,24.164,74.283,56.879,98.375,98.039c24.092,41.153,36.135,85.99,36.135,134.509    C574.852,354.185,562.888,399.399,538.724,440.853z"
                          data-original="#000000"
                          class="active-path"
                          data-old_color="#576ae6"
                          fill="#576ae6"
                        ></path>
                        <path
                          d="M324.906,302.988V129.659c0-10.372-9.037-18.738-19.41-18.738c-9.701,0-18.403,8.366-18.403,18.738v176.005    c0,0.336,0.671,1.678,0.671,2.678c-0.671,6.024,1.007,11.043,5.019,15.062l100.053,100.046c6.695,6.695,19.073,6.695,25.763,0    c7.694-7.695,7.188-18.86,0-26.099L324.906,302.988z"
                          data-original="#000000"
                          class="active-path"
                          data-old_color="#576ae6"
                          fill="#576ae6"
                        ></path>
                      </g>
                    </g>
                  </g>
                </svg>
              </span>
              Log Dispense Error
            </div>
            <!-- Modal close button -->
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="change()"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
                <path
                  fill="#C0C6D8"
                  fill-rule="nonzero"
                  d="M8.254 6.5l4.383-4.382A1.24 1.24 0 0 0 10.882.363L6.5 4.746 2.118.363A1.24 1.24 0 1 0 .363 2.118L4.746 6.5.363 10.882a1.24 1.24 0 0 0 1.755 1.755L6.5 8.254l4.382 4.383a1.24 1.24 0 1 0 1.755-1.755L8.254 6.5z"
                ></path>
              </svg>
            </button>
          </div>
          <!-- Modal Body -->
          <div class="modal__body modal__body--pad">
            <div class>
              <form
                action
                class="form disburse-form"
                @submit.prevent="handleLogTransfer()"
                v-if="logTransferNotFinished"
              >
                <div class="form__item">
                  <label for="beneficiarySource" class="form__label--span form--left">
                    <span>Reference</span>
                  </label>
                  <div class="select form--right">
                    <input
                      type="text"
                      name="name"
                      required="true"
                      disabled=true
                      v-model="createObject.txref"
                      id="txref"
                      class="form__input input"
                      data-vv-id="1"
                      aria-required="true"
                      aria-invalid="false"
                    >
                  </div>
                </div>

                <div class="form__item">
                  <label for="beneficiarySource" class="form__label--span form--left">
                    <span>File</span>
                  </label>
                  <div class="select form--right">
                    <input
                    ref="file"
                    type="file"
                    placeholder="Upload file"
                    required="true"
                    id="file"
                    name="file"
                    aria-invalid="true"
                    style="padding-left: 9px;"
                    @change="fileUpdate()"
                  >
                  </div>
                </div>

                <div class="form__item">
                  <button
                    id="Submit_button"
                    type="submit"
                    class="btn btn--primary btn--block Submit_button"
                  >Log Dispense Error</button>
                </div>
              </form>
              <div class="disburse__result text-center" v-if="logTransferDone">
                <div v-if="logTransferSuccessful">
                  <!--success icon-->
                  <div class="result-img">
                    <svg
                      class="icon icon--custom-big"
                      enable-background="new 0 0 50 50"
                      version="1.1"
                      viewBox="0 0 50 50"
                      xml:space="preserve"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="25" cy="25" r="25" fill="#25AE88"></circle>
                      <polyline
                        points="38 15 22 33 12 25"
                        fill="none"
                        stroke="#fff"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-miterlimit="10"
                        stroke-width="2"
                      ></polyline>
                    </svg>
                  </div>
                  <p
                    class="disburse__result__success success-text"
                  >Transfer logged successfully!</p>
                  <button
                    class="btn btn--default"
                    @click="change()"
                  >End</button>
                </div>

                <div v-if="logTransferFailed">
                  <div class="result-img">
                    <svg
                      enable-background="new 0 0 50 50"
                      version="1.1"
                      viewBox="0 0 50 50"
                      xml:space="preserve"
                      xmlns="http://www.w3.org/2000/svg"
                      class="icon icon--custom-big"
                    >
                      <circle cx="25" cy="25" r="25" fill="#D75A4A"></circle>
                      <polyline
                        points="16 34 25 25 34 16"
                        fill="none"
                        stroke="#fff"
                        stroke-linecap="round"
                        stroke-miterlimit="10"
                        stroke-width="2"
                      ></polyline>
                      <polyline
                        points="16 16 25 25 34 34"
                        fill="none"
                        stroke="#fff"
                        stroke-linecap="round"
                        stroke-miterlimit="10"
                        stroke-width="2"
                      ></polyline>
                    </svg>
                  </div>
                  <p
                    v-for="error in logErrors"
                    class="disburse__result__error error-text"
                  >{{error}}</p>
                  <button class="btn btn--primary" @click="retry3()">Retry</button>
                  <button
                    class="btn btn--default"
                    @click="change()"
                  >End</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
  import {getTranferDetails, getTranferDetailsViaRef, sendReceipts, retryPayout, retryPosCallback, logTransfer} from '../../utils/wallet-transactions/transferService';
  import {blacklistBeneficiary, deleteBlacklistedBenef} from '../../utils/wallet-transactions/beneficiariesService';
  import moment from 'moment';
  import { uploadFile } from "../../utils/upload/fileUpload"

  export default {

    created(){
      this.handleTransferHistory();  // Fetches transfers when the component is created.
      // this.handleSendReceipts();
    },


    mounted(){
    },


    beforeRouteUpdate (to, from, next) {
      this.$Progress.start();
      this.handleTransferHistory();
      this.$Progress.finish();
      // don't forget to call next()
      next()
    },


    data() {
      return {
        transfersList:[],
        transfersEmpty:false,
        showTransferDetails: false,
        selected:false,
        hasMoreInfo:true,
        isLoading: true,
        isActive: false,
        activePanel: {},
        transfer: {},
        reversedTransfer: {},
        type: '',
        email: '',
        toView: false,
        toLogTransfer: false,
        logTransferFailed: false,
        logTransferDone: false,
        logTransferSuccessful: false,
        logTransferNotFinished: true,
        logErrors: [],
        createObject: {
          txref: "",
          link: "",
          merchantId: '',
        },
        file:'',
        error: [],
        toTypeEmail: false,
        initiated: false,
        EmailSentSuccessfully: false,
        EmailFailed: false,
        contains: false,
        alreadyRetrieduccessfully: false,
        shouldShow: false,
        retriedList: false,
        transferWaiting: true,
        transferFailed: false,
        transferSuccessful: false,
        transferErrors: [],
        password: '',
        merchant: window.localStorage.getItem("merchantName"),
        callbackErrors: [],
        callbackMessage: [],
        callbackInitiated: false,
        callbackFailed: false,
        callbackSuccessful: false,
      }
    },
    props:{
      name,
    },
    components:{
    },
    watch: {
      // call again the fetch method if the route changes
      '$route': 'handleTransferHistory'
    },

    computed:{
      permitted() {
        let permission = window.localStorage.getItem('permissions');
        permission = (permission) ? JSON.parse(window.localStorage.getItem('permissions')) : [];
        return !!(permission.includes('wallet.disburse'));
      }
    },

    methods:{
      momentDate(date) {
        return moment(date).format("MMM Do, YYYY . HH:mm:ss")
      },
      handleRetryTransfer(){
        let submitBtn = document.getElementsByClassName("retry_submit");
        submitBtn.disabled = true;
        this.$Progress.start();
        let whatIs = '';
        let requestId = 0;
        let batchId = this.transfer.disburseOrderId;
        if (batchId === null) {
          whatIs = 'Single';
          requestId = this.transfer.id;
        } else {
          whatIs = 'Batch';
          requestId = batchId;
        }
        retryPayout(requestId, whatIs, this.password).then((resp) => {
          this.$Progress.finish();
          this.transferWaiting = false;
          this.transferFailed = false;
          this.transferSuccessful = true;
        })
        .catch((error) => {
          this.$Progress.fail();
          this.transferWaiting = false;
          this.transferFailed = true;
          this.transferSuccessful = false;
          // if (this.password === '')
          if (error.response.data.data == 'Invalid Transaction Id') error.response.data.data = 'Transaction can not be retried';
          this.transferErrors.push(error.response.data.data || error.response.data.message);
        });
      },

      handleTransferHistory(){
        this.type = "";
        this.$Progress.start();
        getTranferDetails(this.$route.params.id).then((resp) => {
          let nextR = false;
          if(resp.status === 200 && resp.data.data && resp.data.data.count === 1){
            console.log(resp.data.data);
            this.transfer = resp.data.data.response[0];
            nextR = getTranferDetailsViaRef(this.transfer.ref, this.$route.params.id);
          } else {
          }
          return nextR;
        })
        .then((nextResp) => {
          let referenceObj = nextResp.data.data.response;
          let retriedListObj = [];
          for (const x in referenceObj) {
            if (referenceObj[x].ref === `${this.transfer.ref}R`) this.reversedTransfer = nextResp.data.data.response[0];
            if (referenceObj[x].status === 'completed' && Number(referenceObj[x].reversed) === 0 && referenceObj[x].system_type != 'wallet-fund') this.alreadyRetrieduccessfully = true;
            if (referenceObj[x].system_type != 'wallet-fund' && referenceObj[x].ref != `${this.transfer.ref}`) retriedListObj.push(referenceObj[x]);
            console.log(referenceObj[x], referenceObj[x].status, Number(referenceObj[x].reversed), referenceObj[x].ref, this.alreadyRetrieduccessfully);
          }
          if (retriedListObj.length > 0) {
            this.retriedList = retriedListObj;
          }

          this.createObject.txref = this.transfer.ref;
          this.createObject.merchantId = window.localStorage.getItem('merchantId');

          this.contains = (this.transfer.ref) ? this.transfer.ref.includes('_RETRY_') : false;
          console.log(!this.contains, this.transfer.reversed === 1, !this.alreadyRetrieduccessfully, this.permitted)
          if (!this.contains && this.transfer.reversed === 1 && !this.alreadyRetrieduccessfully && this.permitted) this.shouldShow = true;
          this.isLoading = false;
          this.$Progress.finish()
        })
        .catch((err) => {
          console.log(err);
        });
      },
      optionType(){
        if(this.type === 'Email'){
          // console.log(this.type);
          this.toTypeEmail = true;
          this.initiated = true;
          // this.handleSendReceipts();
        } else if (this.type === 'View'){
          this.toView = true;
        } else if (this.type === 'Blacklist') {
          blacklistBeneficiary(this.transfer.beneficiaryId).then(resp => this.handleTransferHistory()).catch(err => console.log(err));
        } else if (this.type === 'RFBlacklist') {
          deleteBlacklistedBenef(this.transfer.beneficiaryId).then(resp => this.handleTransferHistory()).catch(err => console.log(err));
        } else if (this.type === 'retryCallBack') {
          this.retryCallBack(this.transfer.ref);
        } else if (this.type === 'logTransfer') {
          this.toLogTransfer = true;
        }
      },
      fileUpdate() {
        this.file = this.$refs.file.files[0];
        if (this.file) {
          let myarray = ["jpeg", 'png', 'pdf', 'jpg'];
          let arraycontain = myarray.indexOf(this.file.name.split('.').pop()) > -1;
          if (arraycontain === false) {
            this.logTransferDone = true;
            this.logTransferNotFinished = false;
            this.logTransferFailed = true;
            this.logTransferSuccessful = false;
            this.logErrors.push('File not accepted');
          }
        } else this.file = null;
        console.log(this.file);
      },
      handleLogTransfer () {
        let submitBtn = document.getElementById("Submit_button");
        submitBtn.disabled = true;
        submitBtn.innerHTML = "Processing...";
        let app = this;
        this.$Progress.start();

        uploadFile(this.file, this.file.name)
        .then((response) => {
          if (!response.data.url) throw Object({})
          this.createObject.link = response.data.url;
          return logTransfer(this.createObject);
        })
        .then((resp) => {
          this.$Progress.finish();

          if (resp.data === 'Ticket Logged') {
            this.logTransferNotFinished = false;
            this.logTransferDone = true;
            this.logTransferSuccessful = true;
            this.logTransferFailed = false;
          }
          submitBtn.disabled = false;
          submitBtn.innerHTML = "Log Dispense Error";
        })
        .catch((err) => {
          this.$Progress.fail();
          submitBtn.disabled = false;
          submitBtn.innerHTML = "Log Dispense Error";
          console.log(err.response || err);
          this.logErrors.push(err.response.data.message || err.response.data.error.message || 'Uploading document Failed');
          this.logTransferDone = true;
          this.logTransferNotFinished = false;
          this.logTransferFailed = true;
          this.logTransferSuccessful = false;
        });
      },
      retryCallBack(ref) {
        this.$Progress.start();
        retryPosCallback(ref)
        .then((resp) => {
          this.callbackInitiated = true;
          this.callbackFailed = false;
          this.callbackSuccessful = true;
          this.callbackMessage.push(`Callback successfully sent to ${resp.data.url.split('?')[0]}`);
          this.$Progress.finish();
        })
        .catch((err) => {
          this.callbackInitiated = true;
          this.callbackFailed = true;
          this.callbackSuccessful = false;
          this.callbackErrors.push(err.response.data.message)
          this.$Progress.fail();
          console.log(err);
        });
      },
      change(){
        this.toTypeEmail = false;
        this.initiated = false;
        this.EmailSentSuccessfully = false;
        this.EmailFailed = false;
        this.error = [];
        this.type = '';
        this.email = '';
        this.toView = false;
        this.contains = false;
        this.alreadyRetrieduccessfully = false;
        this.transferWaiting = true;
        this.transferFailed = false;
        this.transferSuccessful = false;
        this.transferErrors = [];
        this.password = '';
        this.shouldShow = false,
        this.retriedList = false,
        this.callbackInitiated = false;
        this.callbackFailed = false;
        this.callbackSuccessful = false;
        this.callbackMessage = [];
        this.callbackErrors = [];
        this.toLogTransfer = false;
        this.logTransferNotFinished = true;
        this.logErrors = [];
        this.logTransferFailed = false;
        this.logTransferDone = false;
        this.createObject.link = '';
        this.logTransferSuccessful = false;
        this.handleTransferHistory();
      },
      retry(){
        this.toTypeEmail = true;
        this.initiated = true;
        this.EmailSentSuccessfully = false;
        this.EmailFailed = false;
        this.error = [];
      },

      retry2(){
        this.transferWaiting = true;
        this.transferFailed = false;
        this.transferSuccessful = false;
        this.transferErrors = [];
      },

      retry3() {
        this.toLogTransfer = true;
        this.logTransferNotFinished = true;
        this.logErrors = [];
        this.logTransferFailed = false;
        this.logTransferDone = false;
        this.logTransferSuccessful = false;
      },

      handleReportTransfer(){
        // submit transfer ticket
      },


      handleSendReceipts(){
        // console.log(this.type);
        this.$Progress.start();
        sendReceipts(this.$route.params.id, this.email, 'disbursement').then((response) => {
          this.$Progress.finish();
          this.toTypeEmail = false;
          if(response.status === 200){
            response.data.data.m = JSON.parse(response.data.data.m);
            if(response.data.data.m.data.code === '00')
            {
              this.EmailSentSuccessfully = true;
              this.EmailFailed = false
            }
            else{
              this.EmailSentSuccessfully = false;
              this.EmailFailed = true
              this.error.push(response.data.data.m.data.message)
            }
          }
        }).catch((error) => {
          console.log(error.message);
          this.$Progress.fail();
          console.log(error.response.data.message);
          this.error.push(error.response.data.status);
          this.error.push(error.response.data.message);
          this.toTypeEmail = false;
          this.EmailSentSuccessfully = false;
          this.EmailFailed = true
        })
      }
    },

  }
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/transfers/SingleTransfer.vue